document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".pn-announcement-bar").forEach(initBar);

});

function initBar(bar){

  const span = bar.querySelector(".pn-announcement-text");

  const data = JSON.parse(
      bar.querySelector(".pn-announcement-data").textContent
  );

  if(!data.length) return;

  const typingSpeed = Number(span.dataset.speed);
  const pauseTime = Number(span.dataset.pause);
  const fadeTime = Number(span.dataset.fade);

  let index = 0;

  function centerReveal(text){

      return new Promise(resolve=>{

          span.textContent="";

          const chars = Array(text.length).fill(" ");

          const centerLeft = Math.floor((text.length-1)/2);
          const centerRight = centerLeft+1;

          let radius = 0;

          function step(){

              let changed = false;

              const l = centerLeft-radius;
              const r = centerRight+radius-1;

              if(l>=0){
                  chars[l]=text[l];
                  changed=true;
              }

              if(r<text.length){
                  chars[r]=text[r];
                  changed=true;
              }

              span.textContent = chars.join("");

              radius++;

              if(changed){

                  setTimeout(step,typingSpeed);

              }else{

                  resolve();

              }

          }

          step();

      });

  }

  async function play(){

      while(true){

          span.style.opacity=1;

          await centerReveal(data[index].text);

          await wait(pauseTime);

          span.style.opacity=0;

          await wait(fadeTime);

          index++;

          if(index>=data.length){
              index=0;
          }

      }

  }

  play();

}

function wait(ms){

  return new Promise(resolve=>{

      setTimeout(resolve,ms);

  });

}